import styled from '@emotion/styled';
import { Button, TextField } from '@material-ui/core';

export const SearchInputTextField = styled(TextField)`
  margin-left: 12px;
  width: calc(100% - 250px);
  max-width: 280px;
  height: 32px;

  .MuiInputBase-root {
    height: 100%;
    min-height: 32px;
  }

  .MuiInputBase-input {
    font-size: 13px;
    padding-right: 8px;
  }

  .MuiOutlinedInput-adornedStart {
    padding-left: 0;
  }

  .MuiOutlinedInput-adornedEnd {
    padding-right: 0;
  }

  .Mui-focused {
    .MuiSvgIcon-colorDisabled {
      color: #536171;
    }
  }
`;

export const SearchInputButton = styled(Button)<{ active: number }>`
  height: 32px;
  border-left: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 0;
  padding: 0;
  min-width: 46px;
  font-weight: bold;
  color: ${({ active }) => (active ? '#00a4e4' : '#555')};
  border-bottom: ${({ active }) => (active ? ' 4px solid #00a4e4' : 'none')};
`;
